<script setup>
import {
  useHead,
  useScrollTopOnMounted,
  useRoute,
  useSanityQuery,
  computed,
} from '#imports';
import { getCommonMetaTags } from '~/utils/get-common-meta-tags';
import { getQuery as getContactUsPageQuery } from '~/groq-queries/contact-us-page';
import { useImageSource } from '~/composables/use-image-source';

useScrollTopOnMounted();

const route = useRoute();

const title = 'Свяжитесь с нами — DOXA';
const description = 'Свяжитесь с нами';

const contentQuery = getContactUsPageQuery();
const { data: pageContent } = await useSanityQuery(contentQuery);

const ogImageUrl = computed(() =>
  useImageSource({ image: pageContent.value.image })
);

useHead({
  title,
  meta: getCommonMetaTags({
    path: route.fullPath,
    ogType: 'website',
    title,
    description,
    ogImageUrl: ogImageUrl.value,
  }),
});
</script>

<template>
  <div class="contact-us-page">
    <LayoutDefaultPage is-animated-header is-header-shown is-show-only-socials>
      <ArticleContent
        :content="pageContent"
        class="contact-us-page__article-content"
      />
    </LayoutDefaultPage>
  </div>
</template>

<style lang="postcss" scoped>
.contact-us-page {
  min-height: 100vh;

  &__container {
    max-width: var(--content-narrow-max-width);
    margin: 24px auto 80px auto;
    padding: 0;

    @media (--medium-vp) {
      padding: 0 30px;
    }

    @media (--small-vp) {
      padding: 0 12px;
    }
  }

  &__article-content {
    min-height: calc(100vh - 270px);
  }
}
</style>
